var _style, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbohydrate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#414042;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:#414042;}\n\t.st2{fill:#414042;stroke:#414042;stroke-width:0.25;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 15,
    cy: 15,
    r: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.2,9.2L13,14.1c-0.1,0.1-0.1,0.2-0.2,0.4c-0.1,0.5-0.2,1.9,1.2,2.6c1.8,0.8,2.7-0.9,2.7-0.9l1.7-6.3 C18.8,9.1,17.7,8.6,17.2,9.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.9,6.6L14.9,6.6c-0.4,0-0.8-0.3-0.8-0.8v-3c0-0.4,0.3-0.8,0.8-0.8l0,0c0.4,0,0.8,0.3,0.8,0.8v3 C15.7,6.2,15.3,6.6,14.9,6.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.3,9.8L8.3,9.8c-0.3,0.3-0.8,0.3-1.1,0L5.1,7.7c-0.3-0.3-0.3-0.8,0-1.1l0,0c0.3-0.3,0.8-0.3,1.1,0l2.1,2.1 C8.6,9,8.6,9.5,8.3,9.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.6,9.8L21.6,9.8c-0.3-0.3-0.3-0.8,0-1.1l2.1-2.1c0.3-0.3,0.8-0.3,1.1,0l0,0c0.3,0.3,0.3,0.8,0,1.1l-2.1,2.1 C22.4,10.1,21.9,10.1,21.6,9.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15,22.8c-3.8,0-6.9-2.9-7.3-6.5c0-0.4-0.4-0.8-0.9-0.8h0c-0.5,0-1,0.5-0.9,1c0.5,4.6,4.4,8.1,9.1,8.1 s8.6-3.5,9.1-8.1c0.1-0.5-0.4-1-0.9-1h0c-0.5,0-0.8,0.3-0.9,0.8C21.9,20,18.8,22.8,15,22.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbohydrate);
export default __webpack_public_path__ + "static/media/Carbohydrate.d0bbe0ef3e4414de7a5957ee0a0652b1.svg";
export { ForwardRef as ReactComponent };